import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceFormsRoute: InvariantJiraRoute = {
	name: 'csm-experience-forms',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/forms',
	exact: true,
};
